import * as asn1js from "asn1js";
import { Certificate } from "pkijs";
import { Buffer } from 'buffer';

export const decodeCertificate = (base64Cert) => {
    const certBuffer = Buffer.from(base64Cert, 'base64');
    const asn1 = asn1js.fromBER(certBuffer.buffer);
    if (asn1.offset === -1) {
        throw new Error("Failed to decode certificate");
    }
    const certificate = new Certificate({ schema: asn1.result });

    const notBefore = certificate.notBefore.value;
    const notAfter = certificate.notAfter.value;
    const serialNumber = certificate.serialNumber.valueBlock.valueHex;

    return {
        notBefore,
        notAfter,
        serialNumber: Buffer.from(serialNumber, 'hex').toString('hex').toUpperCase()
    };
};
